import { useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";

const API_URL = process.env.REACT_APP_BACKEND_URL;

export default function ShortTrackingRedirect() {
  const { shortCode } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    async function resolve() {
      try {
        const res = await fetch(`${API_URL}/api/tracking/resolve-short/${shortCode}`);
        if (res.ok) {
          const json = await res.json();
          if (json.token) {
            navigate(`/track/${json.token}`, { replace: true });
            return;
          }
        }
      } catch { /* ignore */ }
      navigate("/", { replace: true });
    }
    resolve();
  }, [shortCode, navigate]);

  return (
    <div data-testid="short-tracking-redirect" style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100vh", fontFamily: "Arial, sans-serif", color: "#666" }}>
      Redirecting to your delivery tracking...
    </div>
  );
}
